
class Schedule {
  constructor() {
    this.init();
  }

  init() {
    this.notes = undefined;
    this.days = [];
    for (let idx = 0; idx < 7; idx++) {
      this.days.push({
        open: false,
        start: 0,
        end: 0
      });
    }
  }

  copy() {
    const cp = new Schedule();

    cp.notes = this.notes;
    cp.days = [];
    this.days.forEach(day => {
      cp.days.push({
        open: day.open,
        start: day.start,
        end: day.end,
      })
    });

    return cp;
  }

  buildFromJSON(obj) {
    this.init();

    if (obj) {
      this.notes = obj.notes ? obj.notes : undefined;
      if (obj.days && (obj.days.length === 7)) {
        this.days = [];
        obj.days.forEach(day => {
          this.days.push({
            open: day.open,
            start: day.start,
            end: day.end,
          })
        });
      }
    }
  }

  toString() {
    let result = this.notes ? `${this.notes}: ` : '';
    const DOW = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    this.days.forEach((day, idx) => {
      result += `${DOW[idx]}: ${day.open / 60}:${day.open % 60} - ${day.close / 60} % ${day.close % 60}`;
    });
    return result;
  }

  getNotes() {
    return this.notes;
  }

  setNotes(notes) {
    this.notes = notes;
  }

  getOpen(day) {
    return ((day >= 0) && (day <= 6)) ?  this.days[day].open : undefined;
  }

  setOpen(day, open) {
    if ((day >= 0) && (day <= 6)) {
      this.days[day].open = open;
    }
  }

  getStartHour(day) {
    return ((day >= 0) && (day <= 6)) ?  Math.floor(this.days[day].start / 60) : undefined;
  }

  setStartHour(day, hour) {
    if ((day >= 0) && (day <= 6)) {
      this.days[day].start = (hour * 60) + (this.days[day].start % 60);
    }
  }

  getStartMinute(day) {
    return ((day >= 0) && (day <= 6)) ?  (this.days[day].start % 60) : undefined;
  }

  setStartMinute(day, minute) {
    if ((day >= 0) && (day <= 6)) {
      this.days[day].start = (Math.floor(this.days[day].start / 60) * 60) + minute;
    }
  }

  getEndHour(day) {
    return ((day >= 0) && (day <= 6)) ? Math.floor(this.days[day].end / 60) : undefined;
  }

  setEndHour(day, hour) {
    if ((day >= 0) && (day <= 6)) {
      this.days[day].end = (hour * 60) + (this.days[day].end % 60);
    }
  }

  getEndMinute(day) {
    return ((day >= 0) && (day <= 6)) ? (this.days[day].end % 60) : undefined;
  }

  setEndMinute(day, minute) {
    if ((day >= 0) && (day <= 6)) {
      this.days[day].end = (Math.floor(this.days[day].end / 60) * 60) + minute;
    }
  }
}

module.exports = Schedule;
